export * from './plot/plot.component';
export * from './table/table.component';
export * from './map/map.component';